import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import withStyles from "@material-ui/core/styles/withStyles";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { UploadAdapter } from "../../../classes/UploadAdapter";
import { StylesProvider } from "@material-ui/core/styles";
import "./editor.css";

import AttachFileIcon from "@material-ui/icons/AttachFile";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ProjectFiles from "../../../components/projects/ProjectFiles";
import Button from "@material-ui/core/Button";

const styles = (theme) => ({
  editorMain: {
    position: "relative",
    marginBottom: 50,
  },
  attachFileBtn: {
    position: "absolute",
    top: -5,
    zIndex: 1,
    left: 0,
  },
});

class Editor extends React.PureComponent {
  state = {};
  render() {
    const { ID, profile, firestore, classes, saveBtnClick } = this.props;
    const { value } = this.state;

    return (
      <StylesProvider injectFirst>
        <div className={classes.editorMain}>
          <div className={classes.attachFileBtn}>
            <Tooltip title="Attach File">
              <IconButton
                style={{ position: "relative" }}
                aria-label="Attach File"
              >
                <AttachFileIcon />
                <ProjectFiles
                  newFileUploaded={(url) => {
                    let newVal = value;
                    const a = `<a href="${url}">${url}</a>`;
                    if (newVal) {
                      newVal += a;
                    } else {
                      newVal = a;
                    }
                    this.setState({ value: newVal });
                  }}
                  projectId={ID}
                  small
                  profile={profile}
                  firestore={firestore}
                />
              </IconButton>
            </Tooltip>
          </div>

          <CKEditor
            placeholder="Add comment"
            editor={ClassicEditor}
            data={value}
            onInit={(editor) => {
              console.log("Editor is ready to use!", editor);
            }}
            onChange={(event, editor) => {
              const value = editor.getData();
              // console.log( { event, editor, data } );

              //newComment
              this.setState({ value });

              // this.handleEditorChange(data);
            }}
            onBlur={(event, editor) => {
              // console.log( 'Blur.', editor );
            }}
            onFocus={(event, editor) => {
              // console.log( 'Focus.', editor );
            }}
            onInit={(editor) => {
              editor.ui.view.editable.element.style.height = "200px";
              editor.plugins.get(
                "FileRepository"
              ).createUploadAdapter = function (loader) {
                return new UploadAdapter(loader, ID, profile, firestore);
              };
            }}
            config={{
              placeholder: "Start type your comment here ...",
            }}
          />

          <Button
            style={{ float: "right", margin: "10px 20px -10px 0" }}
            variant="contained"
            color="primary"
            onClick={() => {
              if (value) {
                saveBtnClick(value);
                setTimeout(() => {
                  this.setState({ value: "" });
                }, 500);
              }
            }}
            // startIcon={<AddIcon />}
          >
            Add Comment{" "}
          </Button>
        </div>
      </StylesProvider>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    profile: state.firebase.profile,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [])
)(withStyles(styles)(Editor));
